module.exports = __webpack_public_path__ + "img/smiley-happy.3f4bda58.svg";